import type { HeadingProps } from "@tokenterminal/core/ui/heading/Heading"
import { forwardRef } from "react"
import { twMerge } from "tailwind-merge"
import MarketingHeading from "../../common/MarketingHeading"

/* export const breakpoints = {
  mobile: 0,
  tablet: 720,
  desktop: 1200,
  wideDesktop: 1440,
} as const */

// One visual fragment of the hero sentence. Hero renders the real h1 (sr-only)
const HeroHeading = forwardRef<
  HTMLHeadingElement,
  Omit<HeadingProps, "level"> & {
    animationIndex: number
  }
>(({ animationIndex, className, style, ...props }, ref) => {
  return (
    <MarketingHeading
      level={1}
      as="div"
      aria-hidden
      className={twMerge("hero-heading", className)}
      ref={ref}
      style={{
        animationDelay: `${animationIndex * 100}ms`,
        ...style,
      }}
      {...props}
    />
  )
})

HeroHeading.displayName = "HeroHeading"

export default HeroHeading
